import { Injectable } from '@angular/core';
import * as lodhash from 'lodash';
import { map, Observable } from 'rxjs';
import { OverlayService } from '../overlay/overlay.service';
import { popUpComponent } from './prime-ng-array-d4.service';
import { ModalTextAreaForArrayComponent } from './modal-text-area-for-array/modal-text-area-for-array.component';

@Injectable({
  providedIn: 'root',
})
export class PrimgNgArrayD4ExternalComponentService {
  constructor(
    private overlayService: OverlayService,
  ) { }

  public downloadLink(objectSelected: any, columnDefinitionName: any, event: any) {
    event.stopPropagation();
    console.log(lodhash.get(objectSelected, columnDefinitionName))
    const newWindow = window.open(lodhash.get(objectSelected, columnDefinitionName), '_blank');
    if (newWindow) {
      newWindow.focus();
    }
  }

  public mailLink(objectSelected: any, columnDefinitionName: any, event: any) {
    event.stopPropagation();
    const newWindow = window.open('mailto:' + lodhash.get(objectSelected, columnDefinitionName), '_blank');
    if (newWindow) {
      newWindow.focus();
    }
  }

  public phoneLink(objectSelected: any, columnDefinitionName: any, event: any) {
    event.stopPropagation();
    let phoneNumber = lodhash.get(objectSelected, columnDefinitionName);
    if (phoneNumber.length > 6) {
      const newWindow = window.open('tel:' + phoneNumber, '_blank');
      if (newWindow) {
        newWindow.focus();
      }
    }
  }



  public displayTextArea(columnName: string, object: any, rw: boolean): Observable<any> {
    let width: string = '750px';
    let height: string = '650px';

    const ref = this.overlayService.open(
      ModalTextAreaForArrayComponent,
      { texte: object[columnName], rw: rw },
      {
        styleDefinition: {
          'border-radius': '8px',
          width: width,
          height: height,
          position: 'fixed',
          top: 'calc(50% - 325px)',
          left: 'calc(50% - 375px)',
        },
      },
    );
    return ref.afterClosed$.pipe(
      map((result: any) => {
        if (result.data != undefined) {
          object[columnName] = result.data;
          let eventToWrite = {
            originalEvent: { code: 'Enter', target: { value: result.data } },
            data: object,
            field: columnName,
          };
          return eventToWrite;
        } else return null;
      }),
    );
  }

  public showPopUp(popUpCmp: popUpComponent, object: any, event: any = undefined): Observable<any> {
    let styleDefinition: any = {};

    let width: string = '750px';
    let height: string = '900px';
    if (popUpCmp.data.cmpWidth != null) width = popUpCmp.data.cmpWidth.toString() + 'px';
    if (popUpCmp.data.cmpHeight != null) height = popUpCmp.data.cmpHeight.toString() + 'px';
    styleDefinition = { 'border-radius': '8px', width: width, height: height };

    if (popUpCmp.data['modalMode'] == 'floattingPointerEvent') {
      styleDefinition['position'] = 'fixed';
      styleDefinition['top'] = 30 + event.clientY + 'px';
      styleDefinition['left'] = event.clientX - 10 + 'px';
    } else if (popUpCmp.data['modalMode'] == 'floatting') {
    }

    if (popUpCmp.styleDefinition != undefined) styleDefinition = popUpCmp.styleDefinition;

    const ref = this.overlayService.open(popUpCmp.component, { eventType: popUpCmp.data, item: object }, { styleDefinition: styleDefinition });
    return ref.afterClosed$.pipe(
      map((result: any) => {
        if (result.data != null) return result;
        else return null;
      }),
    );
  }
}
